// extracted by mini-css-extract-plugin
export default {"country-wheel":"CountrySelector_country-wheel__laFSE","country-tooltip":"CountrySelector_country-tooltip__j4G7k"};